"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsPage = RewardsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
function RewardsPage() {
    return (0, jsx_runtime_1.jsx)("div", { children: "Rewards Page" });
}
